import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccessibleGroups } from "../../../../../store/features/groupsApi";
import { clearGroupMailDomainAuth } from "../../../../../store/features/mailDomainAuthApi";
import SettingsContent from "../../shared/SettingsContent";
import SettingsPageHeader from "../../shared/SettingsPageHeader";
import BusinessEmailGroupSelect from "../BusinessEmail/BusinessEmailGroupSelect";
import CustomDomainPanel from "./CustomDomainPanel";
import CustomDomainRequirements from "./CustomDomainRequirements";
import { getActiveGroups, getDefaultGroupId } from "../../shared/groupUtils";

function CustomDomainPage() {
  const dispatch = useDispatch();
  const { list: groups, listLoading } = useSelector((state) => state.peopleGroups);

  const [selectedGroupId, setSelectedGroupId] = useState("");

  const activeGroups = useMemo(() => getActiveGroups(groups), [groups]);
  const defaultGroupId = useMemo(() => getDefaultGroupId(groups), [groups]);
  const resolvedGroupId = selectedGroupId || defaultGroupId;

  useEffect(() => {
    dispatch(fetchAccessibleGroups());
    return () => {
      dispatch(clearGroupMailDomainAuth());
    };
  }, [dispatch]);

  return (
    <SettingsContent>
      <SettingsPageHeader
        title="Custom Domain"
        description="Register and verify a mail domain for outbound ticket replies per group."
      />

      <BusinessEmailGroupSelect
        groups={activeGroups}
        value={resolvedGroupId}
        onChange={setSelectedGroupId}
        loading={listLoading}
      />

      <CustomDomainPanel groupId={resolvedGroupId} />

      <CustomDomainRequirements />
    </SettingsContent>
  );
}

export default CustomDomainPage;
